<template>
  <footer class="footer">
    <div class="container-fluid d-flex flex-wrap justify-content-between align-items-center">
      <nav>
        <ul>
          <li>
            <router-link :to="{ path: '/dashboard' }">Início</router-link>
          </li>
          <li>
            <router-link :to="{ path: '/cotacao' }">Cotação</router-link>
          </li>
          <li>
            <router-link :to="{ path: '/mundos' }">Mundos</router-link>
          </li>
          <li>
            <router-link :to="{ path: '/comparador' }">Comparador</router-link>
          </li>
          <li>
            <router-link :to="{ path: '/varinhas' }">Varinhas</router-link>
          </li>
          <li>
            <router-link :to="{ path: '/sobre' }">Sobre</router-link>
          </li>
        </ul>
      </nav>
      <div class="footer-disclaimer">
        Site de fãs, não oficial. Contato: <a href="mailto:contato@girardon.com.br">contato@girardon.com.br</a>
      </div>
      <div class="copyright">
        &copy; Rubinot Data — rubinotdata.com.br
      </div>
    </div>
  </footer>
</template>
<script>
export default {};
</script>
<style></style>
